import { parseAnyDef } from "./any.js";
export function parseUndefinedDef(refs) {
    return {
        not: parseAnyDef(refs),
    };
}
